export const CHAPTER_CALL_REQUEST = "CHAPTER_CALL_REQUEST";
export const CHAPTER_CALL_SUCCESS = "CHAPTER_CALL_SUCCESS";
export const CHAPTER_CALL_FAILURE = "CHAPTER_CALL_FAILURE";
